module.exports = __webpack_public_path__ + "img/appPrizeTitleImg.a7fd9295.png";